import React from 'react';
import { MARQUEE_ITEMS } from '../mock';

export default function Marquee() {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="bg-[#0f1a2b] border-y border-white/10 overflow-hidden">
      <div className="marquee-track flex whitespace-nowrap py-5">
        {items.map((it, i) => (
          <div key={i} className="flex items-center gap-8 px-6">
            <span className="font-heading font-semibold text-white text-[18px] md:text-[22px] tracking-tight">{it}</span>
            <span className="text-[#f5c518] text-[22px]">/</span>
          </div>
        ))}
      </div>
    </div>
  );
}
